import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePage } from './home/home.page';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../pipes/pipes.module';
import { ComponentsViewComponent } from './components-view/components-view.component';
import { ComponentsModule } from '../components/components.module';
import { CartComponent } from './cart/cart.component';
import { ProfileComponent } from './profile/profile.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { BackgroundImageDirective } from '../directives/background-image.directive';
import { HiddenDirective } from '../directives/hidden.directive';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { ProductScannerComponent } from './product-scanner/product-scanner.component';
import { LoginComponent } from './auth/login/login.component';
import { SignupComponent } from './auth/signup/signup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { InStoreProductsComponent } from './in-store-products/in-store-products.component';
import { OrderConfirmationScannerComponent } from './order-confirmation-scanner/order-confirmation-scanner.component';
import { ScrollHintDirective } from '../directives/scroll-hint.directive';
import { MyOrdersComponent } from './my-orders/my-orders.component';
import { AboutComponent } from './about/about.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SubsidiesComponent } from './subsidies/subsidies.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { ImprintComponent } from './imprint/imprint.component';
import { AccessControlComponent } from './access-control/access-control.component';

const exportAndDeclarations = [
  HomePage,
  ComponentsViewComponent,
  CartComponent,
  ProfileComponent,
  ProductDetailsComponent,
  OrderSummaryComponent,
  ProductScannerComponent,
  LoginComponent,
  SignupComponent,
  ForgotPasswordComponent,
  ChangePasswordComponent,
  InStoreProductsComponent,
  OrderConfirmationScannerComponent,
  MyOrdersComponent,
  AboutComponent,
  WelcomeComponent,
  SubsidiesComponent,
  TermsOfUseComponent,
  ImprintComponent,
  AccessControlComponent,
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...exportAndDeclarations],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    PipesModule,
    ComponentsModule,
    BackgroundImageDirective,
    HiddenDirective,
    ReactiveFormsModule,
    ScrollHintDirective
  ],
  exports: [...exportAndDeclarations],
})
export class PagesModule {}
